import * as React from 'react'
import { LightBulbMessage } from '..'
import { TextDropdown } from '../TextDropdown'

const styles = require('../styles')

const CoverageAmountOptions = [
  { label: '$100,000', value: 100000 },
  { label: '$150,000', value: 150000 },
  { label: '$200,000', value: 200000 },
  { label: '$250,000', value: 250000 },
  { label: '$300,000', value: 300000 },
  { label: '$350,000', value: 350000 },
  { label: '$400,000', value: 400000 },
  { label: '$450,000', value: 450000 },
  { label: '$500,000', value: 500000 },
  { label: '$550,000', value: 550000 },
  { label: '$600,000', value: 600000 },
  { label: '$650,000', value: 650000 },
  { label: '$700,000', value: 700000 },
  { label: '$750,000', value: 750000 },
  { label: '$800,000', value: 800000 },
  { label: '$850,000', value: 850000 },
  { label: '$900,000', value: 900000 },
  { label: '$950,000', value: 950000 },
  { label: '$1,000,000', value: 1000000 },
  { label: '$1,250,000', value: 1250000 },
  { label: '$1,500,000', value: 1500000 },
  { label: '$1,750,000', value: 1750000 },
  { label: '$2,000,000', value: 2000000 },
  { label: '$2,250,000', value: 2250000 },
  { label: '$2,500,000', value: 2500000 },
  { label: '$2,750,000', value: 2750000 },
  { label: '$3,000,000', value: 3000000 },
  { label: '$3,250,000', value: 3250000 },
  { label: '$3,500,000', value: 3500000 },
  { label: '$3,750,000', value: 3750000 },
  { label: '$4,000,000', value: 4000000 },
  { label: '$4,250,000', value: 4250000 },
  { label: '$4,500,000', value: 4500000 },
  { label: '$4,750,000', value: 4750000 },
  { label: '$5,000,000', value: 5000000 },
]
const CoverageDurationOptions = [
  { label: '10 years', value: 10 },
  { label: '15 years', value: 15 },
  { label: '20 years', value: 20 },
  { label: '25 years', value: 25 },
  { label: '30 years', value: 30 },
  { label: '35 years', value: 35 },
  { label: '40 years', value: 40 },
]

interface Props {
  coverageAmount: number
  onCoverageAmountChange: (value: number) => void
  coverageDuration: number
  onDurationChange: (value: number) => void
}

export const SelectCoverage: React.FC<Props> = ({
  coverageAmount,
  onCoverageAmountChange,
  coverageDuration,
  onDurationChange,
}) => (
  <div>
    <h2 className={styles.customizeHeading}>
      Here are your quotes for{' '}
      <TextDropdown selection={coverageAmount} options={CoverageAmountOptions} handleChange={onCoverageAmountChange} />{' '}
      of coverage for the next{' '}
      <TextDropdown selection={coverageDuration} options={CoverageDurationOptions} handleChange={onDurationChange} />
    </h2>
    <div className={styles.lightBulbMessageContainerSm}>
      <LightBulbMessage />
    </div>
  </div>
)
